import React from 'react';
import styled from 'styled-components';
import { Box, Heading } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';
import { publicImageUrl } from '../../../../lib/publicImageUrl';
import Card from './Card';

const Wrapper = styled.div<{ backgroundColor: string }>`
    width: 100%;
    background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'brown')};
`;

const CardsContainer = styled.div`
    display: flex;
    justify-content: center;
    column-gap: ${spaces['4bu']};
    ${mediaQuery.only('small')} {
        flex-direction: column;
    }
`;

interface Props {
    backgroundColor: string;
}

export default function PreviousReports({ backgroundColor }: Props) {
    return (
        <Wrapper backgroundColor={backgroundColor}>
            <Box paddingTop={['2bu', '2bu', '2bu', '2bu']} paddingLeft="2bu">
                <Box display="flex" justifyContent="center" paddingBottom="1.5bu">
                    <Heading accessibilityLevel={7} appearanceLevel={4}>
                        A look back on Freelance
                    </Heading>
                </Box>
                <CardsContainer>
                    <Card
                        title="The Freelance Revolution"
                        year="2020"
                        defaultImage={publicImageUrl(
                            'design-without-borders/2020-report-default.jpeg'
                        )}
                        hoverImage={publicImageUrl('design-without-borders/2020-report-hover.jpeg')}
                        link="/design-without-borders-2020"
                    />
                    <Card
                        title="The Future of Freelance"
                        year="2019"
                        defaultImage={publicImageUrl(
                            'design-without-borders/2019-report-default.jpeg'
                        )}
                        hoverImage={publicImageUrl('design-without-borders/2019-report-hover.jpeg')}
                        link="/design-without-borders-2019"
                    />
                </CardsContainer>
            </Box>
        </Wrapper>
    );
}
